import { createSlice } from "@reduxjs/toolkit";

export interface ProfileState {
    site: 'ncdc' | 'shine';
    status: 'idle' | 'done';
};

const initialState: ProfileState = {
    site: 'ncdc',
    status: 'idle'
};

const ProfileSlice = createSlice({
    name: 'profile',
    initialState,
    reducers: {
        setProfile(state, action) {
            if (action.payload) {
                state.site = action.payload;
            }
            state.status = 'done';
        }
    },
    extraReducers: {}
});

export const { setProfile } = ProfileSlice.actions;
export default ProfileSlice;
